import * as React from "react";

import { Badge } from "@repo/ui/components/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@repo/ui/components/card";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@repo/ui/components/table";
import { createFileRoute } from "@tanstack/react-router";

import { buildIpadFilename } from "@/lib/filename-utils";

export const Route = createFileRoute("/_authed/filenames/game-titles")({
  head: () => ({ meta: [{ title: "Game titles" }] }),
  component: RouteComponent,
});

function RouteComponent() {
  const rows = React.useMemo(
    () => [
      { title: "STAGE 1: stc ArenaS", week: "Week 1", folder: "ARENA", status: "ready" },
      { title: "STAGE 2: Qiddiya City Grid", week: "Week 1", folder: "GRID", status: "ready" },
      {
        title: "STAGE 3: Lenovo Legion Gauntlet",
        week: "Week 2",
        folder: "ATRIUM",
        status: "ready",
      },
      { title: "STAGE 4: Allianz Vault", week: "Week 2", folder: "PAVILION", status: "ready" },
      {
        title: "Qiddiya City Battleground 1",
        week: "Week 3",
        folder: "SECONDARY 1",
        status: "ready",
      },
      {
        title: "Qiddiya City Battleground 2",
        week: "Week 3",
        folder: "SECONDARY 2",
        status: "ready",
      },
      {
        title: "Qiddiya City Battleground 3",
        week: "Week 4",
        folder: "SECONDARY 3",
        status: "ready",
      },
      { title: "stc Contenders", week: "Week 4", folder: "LCQ-1", status: "ready" },
      { title: "stc Contenders", week: "Week 4", folder: "LCQ-2", status: "ready" },
    ],
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>Stage naming preview</CardTitle>
        <CardDescription>Preview a stable file name for each stage bucket.</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Stage name</TableHead>
              <TableHead>Shoot window</TableHead>
              <TableHead>Folder prefix</TableHead>
              <TableHead>iPad filename</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {rows.map((row) => (
              <TableRow key={row.title}>
                <TableCell className="font-medium">{row.title}</TableCell>
                <TableCell>{row.week}</TableCell>
                <TableCell>{row.folder}</TableCell>
                <TableCell className="font-mono text-xs">
                  {buildIpadFilename([row.folder, row.week, row.title])}
                </TableCell>
                <TableCell>
                  <Badge variant={row.status === "ready" ? "secondary" : "outline"}>
                    {row.status}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
